<template>
	<div>
		<router-view />
	</div>
</template>

<script>
	export default {
		name: "app"
	};
</script>

<style lang="less">
	@import "~@/assets/styles/reset.less";
	@import "~@/assets/styles/icon.less";
	body{
		min-height: 100vh;
	}
	.el-dialog__title{
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 500 !important;
		font-size: 20px !important;
		color: #000000 !important;
	}
	.el-icon-close{
		&:hover{
			color: #999 !important;
		}
	}
	.el-message--success {
		background-color: #fff !important;
		border-color: #fff !important;
		box-shadow: 0px 4 11px 0px rgba(0,0,0,0.1);
		border-radius: 9px 9px 9px 9px;
		border: 1px solid #E5E6EB;
		.el-icon-success{
			color: #00A73C !important;
			font-size: 20px;
		}
		.el-message__content{
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #1D2129 !important;
		}
	}
	.topTitle {
		font-family: Roboto, Roboto;
		font-weight: 500;
		font-size: 20px;
		color: #000000;
	}
	.el-dialog__close{
		font-size: 24px !important;
	}
	.backIcon {
		margin-right: 24px;
	}

	.el-container {
		background: #F3F4F6;
	}

	.el-icon-view {
		color: #2563EB;
		font-size: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.el-icon-edit-outline {
		color: #16A34A;
		font-size: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.el-icon-delete {
		color: #cc0000;
		font-size: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.delete {
		color: #cc0000 !important;
	}

	.flex {
		display: flex;
		align-items: center;
	}
	.flex-c{
		justify-content: center;
		flex-direction: column;
	}
	.flex-c-c{
		flex-direction: row;
		justify-content: center;
	}

	.flex-b {
		justify-content: space-between;
	}
	.flex-a{
		justify-content: space-around;
	}
	.flex-only{
		display: flex;
	}
	.flex-wrap{
		flex-wrap: wrap;
	}
	.flex-no-wrap{
		flex-wrap: nowrap;
	}
	.flex-1{
		flex: 1;
	}
	.flex-2{
		flex: 2;
	}
	.flex-3{
		flex: 3;
	}
	.operation-item{
		display: flex;
		align-items: center;
	}
	.pointer{
		cursor: pointer;
	}
	
	.w-33{
		width: 33%;
	}
	.w-25{
		width: 25%;
	}
	.t-c{
		text-align: center;
	}
	.t-r{
		text-align: right;
	}
	.el-dialog{
		border-radius: 18px !important;
	}
	.flex-column-item{
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.titles{
		margin: 20px 0;
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 600;
		font-size: 20px;
		color: #000000;
		position: relative;
		z-index: 9;
		&::after{
			position: absolute;
			content: '';
			z-index: -1;
			bottom: 4px;
			left: 0;
			width: 53px;
			height: 4px;
			background: linear-gradient( 141deg, #10B649 0%, #7FDA4C 100%);
		}
	}
	.score{
		font-family: DINPro, DINPro;
		font-weight: bold;
		font-size: 22px;
		color: #333333;
		span{
			margin-left: 6px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 13px;
			color: #333333;
		}
	}
	.linePrice{
		padding-top: 10px;
		margin-left: 10px;
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 400;
		font-size: 13px;
		color: #CCCCCC;
		text-decoration-line: line-through;
	}
	
	::-webkit-scrollbar {
	    width: 0px; /* 滚动条宽度 */
		height: 0px;
	}
</style>